export default "__VITE_ASSET__1623e2e1__"